import { type WButtonProps, WButton } from "@/components/button/WButton.tsx";
import { ResourceCreateLinks } from "@/modules/api/resourceCreateLinks.ts";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

export function CreateBillingAccount({
    wording = "short",
    ...props
}: Omit<WButtonProps, "action"> & { wording?: "short" | "long" }): ReactNode {
    return (
        <WButton color="primary" action={ResourceCreateLinks.billing_account} {...props}>
            {wording === "short" ? <Trans>Create new</Trans> : <Trans>Create billing account</Trans>}
        </WButton>
    );
}
